/**
 * Privacy helpers to display client names with the surname blurred out.
 *
 * Renders: <first name visible> <blurred surnames (still selectable-able hover)>
 * Usage:
 *   <DisplayName name="João da Silva" />  →  "João <blur>da Silva</blur>"
 */
import React from "react";
import { usePrivacy } from "@/contexts/PrivacyContext";

export function splitName(fullName) {
  const s = (fullName || "").trim();
  if (!s) return { first: "", rest: "" };
  const parts = s.split(/\s+/);
  return { first: parts[0], rest: parts.slice(1).join(" ") };
}

export function firstName(fullName) {
  return splitName(fullName).first;
}

export function DisplayName({ name, className = "" }) {
  const { blurred } = usePrivacy();
  const { first, rest } = splitName(name);
  if (!rest) return <span className={className}>{first}</span>;
  return (
    <span className={className}>
      {first}{" "}
      <span
        className={blurred ? "blur-sm hover:blur-none transition-all select-none" : ""}
        aria-hidden={blurred}
      >
        {rest}
      </span>
    </span>
  );
}
